import { useEffect, useState } from "react";
import api from "@/lib/api";

export const EXEMPT_SALE_TYPES = ["E44", "E46"];

// Sugiere el tipo de e-CF del cliente (tipo de cliente + padrón DGII). El cajero puede cambiarlo.
export function useSuggestedNcf(customerId, ncfTypes, setNcfType) {
  const [hint, setHint] = useState(null);
  useEffect(() => {
    if (!customerId) {
      setHint(null);
      if (ncfTypes.some((s) => s.type_code === "E32")) setNcfType("E32");
      return;
    }
    let alive = true;
    api.get(`/customers/${customerId}/suggested-ncf`).then(({ data }) => {
      if (!alive) return;
      const available = ncfTypes.some((s) => s.type_code === data.type);
      setHint(available ? data : null);
      if (available) setNcfType(data.type);
    }).catch(() => alive && setHint(null));
    return () => { alive = false; };
  }, [customerId, ncfTypes, setNcfType]);
  return hint;
}
